<template>
    <div>
        <div class="columns toolbar-box action-right is-multiline">
            <div class="column is-12">
                <h4 class="title is-3 is-marginless is-paddingless no-border">Determination</h4>
            </div>
            <div class="column is-12 action-box">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger">Delete selected</a>
                    </p>
                    <p class="control">
                        <button @click="openApplicationModal" class="button is-info" >
                            <span class="icon">
                                <i class="icm-new"></i>
                            </span>
                            <span>New</span>
                        </button>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <o-table
                    :data="determinations"
                    :bordered="table.bordered"
                    :striped="table.striped"
                    :narrowed="table.narrowed"
                    :checkable="table.checkable"
                    :mobile-cards="table.mobileCards"
                    :paginated="table.paginated"
                    :pagination-simple="table.paginationSimple"
                    :per-page="table.perPage"
                    :default-sort-direction="table.defaultSortDirection"
                    :default-sort="table.defaultSort"

                    :selected.sync="selected"
                    :checked-rows="checkedRows"
                    @update:checkedRows="$event => checkedRows = $event"
                >
                    <template>
                        <o-table-column #default="{ row }" field="control_number" label="Control Number" sortable>
                            {{ row.control_number }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="status" label="Status" sortable>
                            {{ statusNameById(row.status) }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="applicant_id" label="Applicant" sortable>
                            {{ row.applicant_name }}
                        </o-table-column>

                        <o-table-column #default="{ row }" label="">
                            <o-dropdown hoverable position="bottom-left" class="table-actions">
                                <template #trigger>
                                  <button class="button">
                                    <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                  </button>
                                </template>
                                <o-dropdown-item has-link><a @click.stop="selectApplication(row)">View</a></o-dropdown-item>
                                <o-dropdown-item has-link><a @click.stop="openApplicationModal(row)">Edit</a></o-dropdown-item>
                                <o-dropdown-item has-link><a @click.stop="$emit('task-create', 'determination', row.id)">Create Activity</a></o-dropdown-item>
                            </o-dropdown>
                        </o-table-column>
                    </template>

                  <template #empty>
                    <div class="has-text-centered">
                      No Determination entered
                    </div>
                  </template>
                </o-table>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isApplicationModalActive">
            <application-modal :application="selectedApplication" preselected-type="Determination"/>
        </o-modal>
    </div>
</template>

<script>
    import ApplicationModal from './../../../../components/modals/applications/Layout'
    import Application from './../../../../mixins/Application'
    import Table from '../../../../mixins/Table'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        mixins: [Table, Application],

        components: {
            ApplicationModal
        },

        data() {
            return {
                type: 'determination'
            }
        },

        methods: {
            ...mapActions({
                removeItem: 'determinations/remove'
            }),
        },

        computed: {
            ...mapGetters({
                determinations: 'determinations/currentProjectItems',
            })
        }
    }
</script>
